import { AttendanceSheetResponseDto } from '@/api.types';

/** Minutos entre entrada e saída da lotação; fallback 300 se dados incompletos. */
export function calcularCargaHorariaMaximaFromLotacao(lotacao: {
  entrada?: string;
  saida?: string;
} | null | undefined): number {
  if (!lotacao?.entrada || !lotacao?.saida) {
    return 300;
  }

  const [entradaH, entradaM] = lotacao.entrada.split(':').map(Number);
  const [saidaH, saidaM] = lotacao.saida.split(':').map(Number);

  const entradaMin = entradaH * 60 + entradaM;
  const saidaMin = saidaH * 60 + saidaM;

  return saidaMin - entradaMin;
}

export function obterUltimaJustificativaRejeicao(folha: AttendanceSheetResponseDto): string {
  const assinaturasComJustificativa = folha?.assinaturas
    ?.filter((a) => a.justificativa)
    ?.sort((a, b) => new Date(b.criadoEm).getTime() - new Date(a.criadoEm).getTime());
  return assinaturasComJustificativa?.[0]?.justificativa ?? 'Não informado';
}
